import React, { useEffect, useRef, useState } from "react";
import "./search_input.ui.scss";

interface ISearchInput {
  onSearch: (value: string) => void;
  placeholder?: string;
  debounceMs?: number;
  initialValue?: string;
}

const SearchInput = (props: ISearchInput) => {
  const { onSearch, placeholder = "Search", debounceMs = 300, initialValue = "" } = props;
  const [value, setValue] = useState(initialValue);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setValue(nextValue);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      onSearch(nextValue);
    }, debounceMs);
  };

  return (
    <input
      type="text"
      className="search_input"
      data-testid="search_input"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
    />
  );
};

export default SearchInput;
